<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div>
            <h1>Все достижения</h1>
          </div>
        </div>
      </div>
      <Preloader v-if="isLoading" />
      <div v-else>
        <div class="page__cards">
          <NewItemCard />
          <Card
            v-for="achievement in achievements"
            :key="achievement.id"
            :data="achievement"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewItemCard from "@/user/components/achievements/NewItemCard";
import Card from "@/user/components/achievements/Card";
import Preloader from "@/_shared/components/ui/Preloader";
import { achievementsService } from "@/user/api-services";
export default {
  components: {
    NewItemCard,
    Card,
    Preloader,
  },
  data() {
    return {
      achievements: [],
      isLoading: true,
    };
  },
  async created() {
    await achievementsService.getAll().then(({ data }) => {
      this.isLoading = false;
      this.achievements = data.records;
    });
  },
};
</script>

<style scoped>
.page__cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 0.5em;
  row-gap: 1em;
}
@media (max-width: 1439px) {
  .page__cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 991px) {
  .page__cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 419px) {
  .page__cards {
    display: inline-flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/pages/AllAchievementsPage.vue